import {
  type FetchMeterHistoryValuesPayload,
  type FetchMeterHistoryValuesSuccessPayload,
  type Meter,
  type MetersReceivedPayload,
  type UpdateMeterRequest
} from './meter-types'

import { createAction } from '@reduxjs/toolkit'

/* Action Creators */

export const SetMeterInEditorAction = createAction<Meter | null>('meters/editor/setMeterInEditor')

export const DeleteMeterAction = createAction<{ meterId: string }>('meters/delete/request')
export const DeleteMeterSuccessAction = createAction<{ meterId: string }>('meters/delete/success')

export const FetchMetersAction = createAction('meters/fetch/request')
export const FetchMetersSuccessAction = createAction<MetersReceivedPayload>('meters/fetch/success')
export const FetchMetersFailureAction = createAction('meters/fetch/failure')

export const FetchMeterHistoryValuesAction = createAction<FetchMeterHistoryValuesPayload>('meters/history/request')
export const FetchMeterHistoryValuesSuccessAction = createAction<FetchMeterHistoryValuesSuccessPayload>('meters/history/success')
export const FetchMeterHistoryValuesFailedAction = createAction('meters/history/failure')

export const UpdateMeterAction = createAction<UpdateMeterRequest>('meters/update/request')
export const UpdateMeterSuccessAction = createAction<Meter>('meters/update/success')
